import { useQuery } from '@tanstack/react-query';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export function useGetAdviceMaintenanceReport(adviceId: string, month: string) {
	const forBinding = useForBindingId();

	return useQuery({
		queryKey: ['maintenance', adviceId, 'report', month],
		queryFn: async () => {
			try {
				const { data } = await api.get<Blob>(
					`/advices/fertilization-plan/report/${adviceId}`,
					{
						params: { forBinding, month },
						responseType: 'blob',
					}
				);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao gerar o relatório de manutenção');
			}
		},
		enabled: !!adviceId && !!month,
	});
}
